/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-microphone-off': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5.737 11.606a4.631 4.631 0 01-.112-.981V8.75h-1.25v1.875c-.002.68.12 1.353.362 1.988l1-1.007zm2.388-2.231v-5a1.875 1.875 0 113.75 0v1.094l1.25-1.25a3.126 3.126 0 10-6.25.156v5h1.25zm6.25 1.25a4.375 4.375 0 01-7.331 3.213l.887-.882a3.125 3.125 0 005.194-2.331V7.763l5.625-5.625-.881-.888L1.25 17.869l.881.881 4.025-4.025a5.569 5.569 0 003.219 1.487V17.5h-2.5v1.25h6.25V17.5h-2.5v-1.288a5.625 5.625 0 005-5.587V8.75h-1.25v1.875zm-2.5 0a1.875 1.875 0 01-3.063 1.444l3.063-3.057v1.613z"/>'
  }
})
